import { get, post } from '.';

export function GetConferenceEvents(options = {}) {
	return get<any>("/app/api/conference_events", options);
}

export function CreateConferenceEvent(options = {}) {
	return post<any>(`/app/api/conference_events`, options);
}